import type { IShellReplyValues } from '@featit/shared';
import { requestShell } from './shellBridge';
import { hasShellCapability } from './shellDetection';

/**
 * F-0332, ADR-151 §3: a session the app got by QR pairing renews only with its device key's
 * signature over a fresh nonce. The key is the shell's, in the Secure Enclave; the web asks the shell
 * to sign and never sees the key.
 *
 * A leaf, like the session vault: `ApiService` is its caller. `null` for anything that is not a
 * shell able to sign, or a deployment with no paired key — the refresh then stands as refused.
 */
export async function shellDeviceProof(nonce: string): Promise<string | null> {
  if (!hasShellCapability('deviceKey')) return null;
  try {
    const proof = await requestShell<IShellReplyValues['deviceProof']>({
      type: 'deviceProof',
      nonce,
    });
    return proof && typeof proof.signature === 'string' && proof.signature ? proof.signature : null;
  } catch (error) {
    console.warn('[featit] shell device proof failed', error);
    return null;
  }
}
